import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { history } from "../store";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import {
  FileCheck,
  LockKeyholeOpen,
  ServerCog,
  DoorOpen,
  Download,
  RefreshCw,
} from "lucide-react";

import AppHeader from "../containers/AppHeader";
import { withNamespaces } from "react-i18next";
import {
  postBookemail,
  postQrsale,
  postBooking,
  postRedsysGetParams,
  fetchCustomer,
} from "../actions/qrs";
import { currencySymbol } from '../utils/currency';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const ticketKey = (id) => `vacway_ticket_${id}`;

class TicketView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pin: "*123456#",
      numero: "123",
      factura: "VLK0001000001",
      iva: 21,
      importeBase: null,
      importeIva: null,
      total: null,
      date: null,
      accessCode: "",
      forwardScreen: false,
      downloadingPDF: false,
      phoneNumber: "",
      mail: "",
      parque: "AQUALANDIA",
      zona: "1",
      accesible: "NO",
      reserva: "TODO EL DIA",
      confirmReservation: false,
      newsletterAcceptance: false,
      lockerPrice: null,
      descriptionZone: null,
      selectedAccessibility: null,
      zoneSelected: null,
      selectedLocker: null,
      lockerAssigned: null,
      lockerPrice: null,
      paymentId: null,
      qrToken: null,
      lockerPin: null,
      lockerMatricula: null,
      lockerCustomer: null,
      lockerInvoice: null,
      qrType: "pay",
      qrMode: 0,
      autorized: null,
      Ds_MerchantCode: null,
      Ds_MerchantName: "VACWAY TECH",
      Ds_Url: "https://vacway.com",
      Ds_AuthorisationCode: null,
      Ds_Date: null,
      Ds_Hour: null,
      Ds_Amount: null,
      startDate: new Date(),
      endDate: new Date(),
      doorAccess: 0,
    };

    this.generatePDF = this.generatePDF.bind(this);
  }

  goTo(number, e) {
    const searchParams = new URLSearchParams(this.props.location.search);
    const qrToken = searchParams.get("qrToken");

    history.push(`/qrsale/${qrToken}`);
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.handleBeforeUnload);

    // Intercept back navigation and redirect to QR start instead
    const urlParams = new URLSearchParams(this.props.location.search);
    const qrToken = urlParams.get("qrToken");
    this.unblockHistory = history.block(() => {
      if (this.unblockHistory) this.unblockHistory();
      history.replace(`/qrsale/${qrToken}`);
      return false;
    });


    const zoneSelected         = urlParams.get("zoneSelected");
    const descriptionZone      = urlParams.get("descriptionZone");
    const selectedAccessibility = urlParams.get("selectedAccessibility");
    const selectedLocker       = urlParams.get("selectedLocker");
    const lockerPrice          = urlParams.get("lockerPrice");
    const lockerAssigned       = urlParams.get("lockerAssigned");
    const lockerPin            = urlParams.get("lockerPin");
    const lockerMatricula      = urlParams.get("lockerMatricula");
    const lockerCustomer       = urlParams.get("lockerCustomer");
    const qrType               = urlParams.get("qrType");
    const qrMode               = urlParams.get("qrMode");
    const mail                 = urlParams.get("mail");
    const phoneNumber          = urlParams.get("phoneNumber");
    const newsletterAcceptance = urlParams.get("newsletterAcceptance");
    const confirmReservation   = urlParams.get("confirmReservation");
    const idNumber             = urlParams.get("idNumber") || '';
    const paymentId            = urlParams.get("paymentId");
    const language             = urlParams.get("language");
    const paymentDate          = new Date(urlParams.get("paymentDate"));
    const customerId           = urlParams.get("customerId");
    const dsSignatureVersion   = urlParams.get("Ds_SignatureVersion");
    const dsMerchantParameters = urlParams.get("Ds_MerchantParameters");
    const dsSignature          = urlParams.get("Ds_Signature");

    this.props.i18n.changeLanguage(language);

    // Retrieve & display the Redsys payment info (auth code, date, hour) returned on
    // the redirect back from a real card payment — mirrors the Baqueira/Rental tickets.
    // Idempotent, so it runs on every mount (first load and reload/restore). The
    // returned promise resolves the decoded auth data so the Sale can carry it too.
    this._paymentInfoPromise = this.fetchRedsysPaymentInfo(customerId, dsSignatureVersion, dsMerchantParameters, dsSignature);

    // Addon Payments (HPP) landings carry the receipt data as plain params —
    // already validated server-side by qrs/gp-response before redirecting here.
    const gpAuthCode = urlParams.get("gpAuthCode");
    const gpPasRef = urlParams.get("gpPasRef");
    if (gpAuthCode) {
      this.setState({ Ds_AuthorisationCode: gpAuthCode });
    }

    let today = new Date().toLocaleString();
    this.setState({ date: today });

    // ── Reload guard: restore from sessionStorage if ticket already processed ──
    const savedTicket = (() => {
      try { return JSON.parse(sessionStorage.getItem(ticketKey(lockerAssigned))); } catch { return null; }
    })();

    if (savedTicket && savedTicket.lockerAssigned === lockerAssigned) {
      // Restore all URL-derived state plus the API result — no API calls needed
      this.setState({
        zoneSelected,
        descriptionZone,
        selectedAccessibility,
        selectedLocker,
        lockerAssigned,
        lockerPrice,
        paymentId,
        qrToken,
        lockerPin,
        lockerMatricula,
        lockerCustomer,
        qrType,
        qrMode:       Number(qrMode),
        lockerInvoice: savedTicket.lockerInvoice,
        accessCode:    savedTicket.accessCode,
        doorAccess:    savedTicket.doorAccess || 0,
        autorized:     true,
      }, () => this.TotalComponent());
      return;
    }

    // ── First-time authorization: block on page reload or non-today paymentDate ──
    let autorizeBookemail = true;

    const navigationEntries = window.performance.getEntriesByType("navigation");
    if (navigationEntries.length > 0 && navigationEntries[0].type === "reload") {
      console.log("Page was reloaded");
      autorizeBookemail = false;
    }

    const now = new Date();
    const isToday =
      paymentDate.getFullYear() === now.getFullYear() &&
      paymentDate.getMonth()    === now.getMonth()    &&
      paymentDate.getDate()     === now.getDate();

    if (!isToday) {
      autorizeBookemail = false;
      console.log("Ticket date is not today – possible reload or duplicate.");
    }

    this.setState({ autorized: autorizeBookemail });

    if (!autorizeBookemail) return;

    const { iva } = this.state;

    let salePetition = {};
    let bookEmail    = {};

    const madridTime = new Date(
      new Date().toLocaleString("en-US", { timeZone: "Europe/Madrid" })
    );
    const formattedDate = madridTime.toISOString().replace("T", " ").substring(0, 19);

    salePetition.TimeStamp     = formattedDate;
    salePetition.Amount        = parseInt(lockerPrice);
    salePetition.Code          = qrToken;
    salePetition.PaymentMethod = "QR";
    salePetition.WorkerSession = "000000";
    salePetition.Language      = language;
    salePetition.RedsysCode    = paymentId;
    salePetition.Locker        = lockerAssigned;
    salePetition.LockerPin     = lockerPin;
    salePetition.Phone         = phoneNumber;
    salePetition.Email         = mail;
    salePetition.IdNumber      = idNumber;

    // Seconds from QR scan (timer set in HomeView) to this ticket view —
    // same OperationTime metric the machine app reports.
    const opStart = Number(sessionStorage.getItem("vacway_op_start"));
    salePetition.OperationTime = opStart > 0 ? Math.round((Date.now() - opStart) / 1000) : 0;

    this.setState(
      {
        zoneSelected,
        descriptionZone,
        selectedAccessibility,
        selectedLocker,
        lockerAssigned,
        lockerPrice,
        paymentId,
        qrToken,
        lockerPin,
        lockerMatricula,
        lockerCustomer,
        qrType,
        lockerInvoice: "XXXXXXXX",
        qrMode: Number(qrMode),
      },
      () => {
        this.TotalComponent();

        this.props
          .postBooking({
            LockerAssigned: lockerAssigned,
            LockerPin:      lockerPin,
            Phone:          phoneNumber,
            Origin:         "RQ",
            qrMode:         qrMode,
          })
          .then(() => {})
          .catch(console.error);
      }
    );

    // Carry the payment authorization into the Sale itself (like the rental
    // flux does). Addon codes come as plain params; the Redsys redirect needs
    // the async decode — wait briefly for it, but never block the sale on it.
    const authPromise = gpAuthCode
      ? Promise.resolve({ AuthCode: gpAuthCode, PasRef: gpPasRef || "" })
      : Promise.race([
          this._paymentInfoPromise || Promise.resolve(null),
          new Promise((resolve) => setTimeout(() => resolve(null), 5000)),
        ]);

    authPromise.then((paymentAuth) => {
      if (paymentAuth && paymentAuth.AuthCode && paymentAuth.AuthCode !== "N/A") {
        salePetition.AuthCode = paymentAuth.AuthCode;
        salePetition.PasRef = paymentAuth.PasRef || "";
      }

    this.props
      .postQrsale(salePetition)
      .then((answer) => {
        if (answer.response && answer.response.toSaveSale) {
          const answerSaleCode = answer.response.toSaveSale.Code;

          this.setState({ lockerInvoice: answerSaleCode });

          bookEmail.bookEmail            = mail;
          bookEmail.lockerMatricula      = lockerMatricula;
          bookEmail.lockerAssigned       = lockerAssigned;
          bookEmail.phoneNumber          = phoneNumber;
          bookEmail.lockerPin            = lockerPin;
          bookEmail.zoneSelected         = zoneSelected;
          bookEmail.selectedLocker       = selectedLocker;
          bookEmail.selectedAccessibility = selectedAccessibility;
          bookEmail.descriptionZone      = descriptionZone;
          bookEmail.lockerSelected       = this.getLockerType(selectedLocker);
          bookEmail.lockerCustomer       = lockerCustomer;
          bookEmail.lockerInvoice        = answerSaleCode;
          bookEmail.date                 = today;
          bookEmail.iva                  = iva;
          bookEmail.importeBase          = (lockerPrice / (1 + iva / 100)).toFixed(2);
          bookEmail.importeIva           = (lockerPrice - lockerPrice / (1 + iva / 100)).toFixed(2);
          bookEmail.total                = lockerPrice;
          bookEmail.qrMode               = qrMode;
          bookEmail.language             = language;
          bookEmail.Ds_MerchantParameters = dsMerchantParameters;

          this.props
            .postBookemail(bookEmail)
            .then((answer) => {
              const accessCode = answer.response.openingAccessCode;
              const doorCode   = answer.response.doorAccess || 0;

              this.setState({ accessCode, doorAccess: doorCode }, () => this.TotalComponent());

              // Persist to sessionStorage so reload restores the ticket without API calls
              try {
                sessionStorage.setItem(ticketKey(lockerAssigned), JSON.stringify({
                  lockerAssigned,
                  lockerInvoice: answerSaleCode,
                  accessCode,
                  doorAccess: doorCode,
                }));
              } catch { /* ignore */ }
            })
            .catch(console.error);
        }
      })
      .catch(console.error);
    });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    if (this.unblockHistory) this.unblockHistory();
    const lockerAssigned = new URLSearchParams(this.props.location.search).get("lockerAssigned") || this.state.lockerAssigned;
    sessionStorage.removeItem(ticketKey(lockerAssigned));
  }

  handleBeforeUnload = (event) => {
    // Set the returnValue property of the event to show the alert message
    event.preventDefault();
  };

  getImageDataURL = (imageUrl) => {
    return new Promise((resolve, reject) => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const image = new Image();

      image.onload = () => {
        canvas.width = image.width;
        canvas.height = image.height;
        ctx.drawImage(image, 0, 0);

        const dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };

      image.onerror = (error) => {
        reject(error);
      };

      image.src = imageUrl;
    });
  };

  fetchRedsysPaymentInfo(customerId, dsSignatureVersion, dsMerchantParameters, dsSignature) {
    // These signed params are only present when Redsys redirects back after a real
    // card payment (qrType "pay"/"test"). Free reservations have no payment, so skip.
    if (!customerId || !dsMerchantParameters || !dsSignature) return Promise.resolve(null);

    return this.props
      .fetchCustomer(customerId)
      .then((customer) => {
        if (!customer?.response?.Redsys) {
          throw new Error("Invalid customer response or missing Redsys data");
        }

        // Redsys never returns the merchant name in Ds_MerchantParameters (only the
        // FUC), so resolve it from the customer record that owns the Redsys config.
        const merchantName =
          customer.response.Social_name || customer.response.Fullname;
        if (merchantName) this.setState({ Ds_MerchantName: merchantName });

        return this.props.postRedsysGetParams({
          Ds_SignatureVersion: dsSignatureVersion,
          Ds_MerchantParameters: dsMerchantParameters,
          Ds_Signature: dsSignature,
          parameterToFetch: "all",
          secretKey: customer.response.Redsys.SECRETKEY,
        });
      })
      .then((answer) => {
        const decoded = answer.response.decodedParams || {};
        this.setState({
          Ds_AuthorisationCode: decoded.Ds_AuthorisationCode || "N/A",
          Ds_MerchantCode:      decoded.Ds_MerchantCode      || "N/A",
          Ds_Date:              decoded.Ds_Date              || new Date().toLocaleDateString(),
          Ds_Hour:              decoded.Ds_Hour              || new Date().toLocaleTimeString(),
          Ds_Amount:            decoded.Ds_Amount            || null,
        });
        // Resolved so the Sale creation can persist the authorization too
        return { AuthCode: decoded.Ds_AuthorisationCode || "", PasRef: "" };
      })
      .catch((error) => {
        console.error("Redsys params error:", error);
        return null;
      });
  }

  TotalComponent() {
    const { iva, lockerPrice } = this.state;

    let importeBase = (lockerPrice / (1 + iva / 100)).toFixed(2);
    let importeIva = (lockerPrice - importeBase).toFixed(2);
    let total = lockerPrice;

    this.setState({
      importeBase: importeBase,
      importeIva: importeIva,
      total: total,
    });

    return { total, importeBase, importeIva, iva };
  }

  openLocker(qrToken) {
    console.log("forwardScreen: ", this.state.forwardScreen);

    window.location.href = `https://lockers-qr.vacway.es/qrsale/${qrToken}`;
  }

  getLockerType(type) {
    const { t, i18n } = this.props;

    switch (type) {
      case "BNS":
        return "Standard";
      case "CNS":
        return "Standard Carga";
      case "BWS":
        return "Standard XL";
      case "BNM":
        return "Medium";
      case "CNM":
        return "Medium Carga";
      case "BWM":
        return "Medium XL";
      case "CWM":
        return "Medium Carga XL";
      case "BNL":
        return "Large";
      case "CNL":
        return "Large Carga";
      case "BWL":
        return "Large XL";
      case "CWL":
        return "Large Carga XL";
      case "BNXL":
        return "Large";
      case "CNXL":
        return "Large Carga";
      case "BWXL":
        return "Large XL";
      case "CWXL":
        return "Large Carga XL";
      case "BN2XL":
        return "Large";
      case "CN2XL":
        return "Large Carga";
      case "BW2XL":
        return "Large XL";
      case "CW2XL":
        return "Large Carga XL";
      case "BN3XL":
        return "Ski";
      case "CN3XL":
        return "Ski Carga";
      case "BW3XL":
        return "Ski XL";
      case "BW3XL":
        return "Ski Carga XL";
      default:
        return "None";
    }
  }

  render() {
    const { t } = this.props;
    const {
      iva,
      importeBase,
      importeIva,
      total,
      accessCode,
      downloadingPDF,
      zoneSelected,
      selectedLocker,
      lockerMatricula,
      lockerPin,
      lockerInvoice,
      descriptionZone,
      qrToken,
      qrMode,
      autorized,
      doorAccess,
      Ds_AuthorisationCode,
      Ds_Date,
      Ds_Hour,
      Ds_Amount,
      Ds_MerchantCode,
      Ds_MerchantName,
      Ds_Url,
    } = this.state;

    if (!autorized) {
      const unauthContent = (
        <>
          <div className="nm-page-header-card">
            <div className="nm-page-header-card-text">
              <h3>{t("¡GRACIAS POR RESERVAR TU TAQUILLA!")}</h3>
              <span className="nm-page-header-zone">
                {t("Sigue las instrucciones que encontrarás a continuación o en tu email.")}
              </span>
            </div>
            <FileCheck className="nm-form-icon" strokeWidth={1} />
          </div>
          <div className="nm-form" style={{ textAlign: 'center' }}>
            <div className="nm-btn-continue" onClick={() => this.goTo(1)}>
              {t("Volver al inicio")}
            </div>
          </div>
        </>
      );
      return (
        <div className="normalBackground">
          <AppHeader />
          <div className="nm-page smartphone">{unauthContent}</div>
          <div className="nm-page pc">{unauthContent}</div>
        </div>
      );
    }

    if (!total) {
      return (
        <div className="spinner">
          <img src="/images/logo.png" alt="Logo" />
        </div>
      );
    }

    const isPinMode = qrMode === 0 || qrMode === 3;
    const codeLabel = isPinMode ? t("PIN") : t("CÓDIGO DE ACCESO");
    const codeValue = isPinMode ? lockerPin : accessCode;

    const steps = qrMode === 1
      ? [
          { img: '/images/qr.png',                      text: 'APRIETA "ABRIR TAQUILLA" O ESCANEA EL QR' },
          { img: '/images/lockerOTOStep2.svg',           text: 'ACCEDE CON TUS CREDENCIALES' },
          { img: '/images/lockerOpen.png',               text: 'SELECCIONA ABRIR AHORA' },
          { img: '/images/lockerBasicOpenedStep4.svg',   text: 'DISPONES DE 2 APERTURAS' },
        ]
      : qrMode === 3
      ? [
          { img: '/images/lockerBasicClosedStep1.svg',   text: 'LOCALIZA TU TAQUILLA' },
          { img: '/images/lockerBasicClosedStep2.svg',   text: 'TOCA EL TECLADO' },
          { img: '/images/lockerBasicClosedStep3.svg',   text: 'INTRODUCE TU PIN' },
          { img: '/images/lockerBasicOpenedStep4.svg',   text: 'ABRE 1 VEZ PARA GUARDAR TUS COSAS, UNA VEZ CIERRES DISPONES DE UNA APERTURA MÁS PARA SACARLAS' },
        ]
      : [
          { img: '/images/lockerBasicClosedStep1.svg',   text: 'LOCALIZA TU TAQUILLA' },
          { img: '/images/lockerBasicClosedStep2.svg',   text: 'TOCA EL TECLADO' },
          { img: '/images/lockerBasicClosedStep3.svg',   text: 'INTRODUCE TU PIN' },
          { img: '/images/lockerBasicOpenedStep4.svg',   text: 'ABRE LAS VECES QUE QUIERAS' },
        ];

    const successBanner = (
      <div className="nm-ticket-success-banner">
        <div className="nm-ticket-success-text">
          <h3>{t("Proceso completado, taquilla reservada.")}</h3>
          <p>{t("Sigue las instrucciones que encontrarás a continuación o en tu email.")}</p>
        </div>
        <img src="/images/animated-icons/firecracker.gif" alt="success" className="nm-ticket-confetti" />
      </div>
    );

    const accessCard = (
      <div className="nm-form nm-ticket-access-card">
        <div className="nm-ticket-card-header">
          <div className="nm-page-header-card-text">
            <h3>{t("Información de taquilla")}</h3>
          </div>
          <LockKeyholeOpen className="nm-form-icon" strokeWidth={1} />
        </div>

        <div className="nm-ticket-code-row">
          <div className="nm-ticket-code-item">
            <span className="nm-ticket-code-label">{t("Nº TAQUILLA")}</span>
            <span className="nm-ticket-code-value">{lockerMatricula}</span>
          </div>
          <div className="nm-ticket-code-sep" />
          <div className="nm-ticket-code-item">
            <span className="nm-ticket-code-label">{codeLabel}</span>
            <span className="nm-ticket-code-value">{codeValue}</span>
          </div>
        </div>

        {!isPinMode && (
          <div
            className="nm-btn-continue"
            style={{ marginTop: 16 }}
            onClick={() => this.openLocker(qrToken)}
          >
            {t("ABRIR TAQUILLA")}
          </div>
        )}

        <p className="nm-phone-privacy" style={{ marginTop: 16 }}>
          {t("*Si deseas obtener el Pin en formato físico para llevarlo durante tu estancia en el parque contacta con los responsables de la zona de taquillas y enséñales tu email de reserva.")}
        </p>
      </div>
    );

    const doorCard = doorAccess != 0 && doorAccess !== "" && (
      <div className="nm-form nm-ticket-door-card">
        <div className="nm-ticket-card-header">
          <div className="nm-page-header-card-text">
            <h3>{t("ACCESO A LOCAL")}</h3>
          </div>
          <DoorOpen className="nm-form-icon" strokeWidth={1} />
        </div>
        <div className="nm-ticket-code-row">
          <div className="nm-ticket-code-item">
            <span className="nm-ticket-code-label">{t("CÓDIGO DE ACCESO")}</span>
            <span className="nm-ticket-code-value">{doorAccess}</span>
          </div>
        </div>
      </div>
    );

    const summaryCard = (
      <div className="nm-form">
        <div className="nm-ticket-card-header">
          <div className="nm-page-header-card-text">
            <h3>{t("Resumen de reserva")}</h3>
          </div>
          <FileCheck className="nm-form-icon" strokeWidth={1} />
        </div>

        <div className="nm-pay-fields">
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t("Código de reserva")}</span>
            <span className="nm-pay-field-value nm-pay-field-value-sm">{lockerInvoice}</span>
          </div>
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t("Zona")}</span>
            <span className="nm-pay-field-value nm-pay-field-value-sm">{zoneSelected} — {descriptionZone}</span>
          </div>
        </div>

        <div className="nm-pay-divider" />

        <div className="nm-pay-fields">
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t("Inicio")}</span>
            <span className="nm-pay-field-value">{new Date().toLocaleDateString()}</span>
          </div>
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t("Fin")}</span>
            <span className="nm-pay-field-value">{new Date().toLocaleDateString()}</span>
          </div>
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t("Hora Límite")}</span>
            <span className="nm-pay-field-value">23:59</span>
          </div>
          <div className="nm-pay-field">
            <span className="nm-pay-field-label">{t("Taquilla")}</span>
            <span className="nm-pay-field-value">{this.getLockerType(selectedLocker)}</span>
          </div>
        </div>

        <div className="nm-pay-divider" />

        <div className="nm-pay-price-section">
          <div className="nm-pay-price-row">
            <span className="nm-pay-price-label">{t("Base")}</span>
            <span className="nm-pay-price-value">{importeBase}{currencySymbol()}</span>
          </div>
          <div className="nm-pay-price-row">
            <span className="nm-pay-price-label">{t("IVA")} ({iva}%)</span>
            <span className="nm-pay-price-value">{importeIva}{currencySymbol()}</span>
          </div>
        </div>
        <div className="nm-pay-price-total-row">
          <span className="nm-pay-price-total-label">{t("Total")}</span>
          <span className="nm-pay-price-total-amount">{total}{currencySymbol()}</span>
        </div>

        {Ds_AuthorisationCode && Ds_AuthorisationCode !== "N/A" && (
          <>
            <div className="nm-pay-divider" />
            <div className="nm-pay-fields">
              <div className="nm-pay-field">
                <span className="nm-pay-field-label">{t("FUC del comercio")}</span>
                <span className="nm-pay-field-value nm-pay-field-value-sm">{Ds_MerchantCode}</span>
              </div>
              <div className="nm-pay-field">
                <span className="nm-pay-field-label">{t("Nombre del comercio")}</span>
                <span className="nm-pay-field-value nm-pay-field-value-sm">{Ds_MerchantName}</span>
              </div>
              <div className="nm-pay-field">
                <span className="nm-pay-field-label">{t("URL del comercio")}</span>
                <span className="nm-pay-field-value nm-pay-field-value-sm">{Ds_Url}</span>
              </div>
              <div className="nm-pay-field">
                <span className="nm-pay-field-label">{t("Importe de la operación")}</span>
                <span className="nm-pay-field-value nm-pay-field-value-sm">{Ds_Amount ? (Number(Ds_Amount) / 100).toFixed(2) : total} {currencySymbol()}</span>
              </div>
              <div className="nm-pay-field">
                <span className="nm-pay-field-label">{t("Código de autorización")}</span>
                <span className="nm-pay-field-value nm-pay-field-value-sm">{Ds_AuthorisationCode}</span>
              </div>
              <div className="nm-pay-field">
                <span className="nm-pay-field-label">{t("Fecha / hora de la operación")}</span>
                <span className="nm-pay-field-value nm-pay-field-value-sm">{Ds_Hour} {Ds_Date}</span>
              </div>
            </div>
          </>
        )}

      </div>
    );

    const instructionsCard = (
      <div className="nm-form nm-ticket-instructions">
        <div className="nm-ticket-card-header">
          <div className="nm-page-header-card-text">
            <h3>{t("Instrucciones")}</h3>
          </div>
          <ServerCog className="nm-form-icon" strokeWidth={1} />
        </div>

        {steps.map((step, i) => (
          <div key={i} className="nm-ticket-step">
            <div className="nm-ticket-step-num">{i + 1}</div>
            <img src={step.img} alt={`Paso ${i + 1}`} className="nm-ticket-step-img" />
            <div className="nm-ticket-step-body">
              <span className="nm-ticket-step-label">{t("PASO")} {i + 1}</span>
              <span className="nm-ticket-step-text">{t(step.text)}</span>
            </div>
          </div>
        ))}
      </div>
    );

    const actionBar = (
      <div className="nm-sb nm-ticket-action-bar">
        <div className="nm-sb-inner nm-ticket-action-bar-inner">
          <button
            className="nm-ticket-action-btn nm-ticket-action-btn-download"
            onClick={this.generatePDF}
            disabled={downloadingPDF}
          >
            {downloadingPDF
              ? <span className="nm-btn-spinner" />
              : <Download size={18} strokeWidth={2} />
            }
            <span>{t("DESCARGAR TICKET")}</span>
          </button>
          <button
            className="nm-ticket-action-btn nm-ticket-action-btn-new"
            onClick={() => this.goTo()}
          >
            <RefreshCw size={18} strokeWidth={2} />
            <span>{t("Alquilar otra taquilla")}</span>
          </button>
        </div>
      </div>
    );

    return (
      <div className="normalBackground">
        <AppHeader />

        {/* ── Mobile ── */}
        <div className="nm-page smartphone">
          {successBanner}
          {accessCard}
          {doorCard}
          {summaryCard}
          {instructionsCard}
        </div>

        {/* ── Desktop ── */}
        <div className="nm-page pc">
          {successBanner}
          <div className="nm-ticket-pc-grid">
            <div className="nm-ticket-pc-col-left">
              {accessCard}
              {doorCard}
              {instructionsCard}
            </div>
            <div className="nm-ticket-pc-col-right">
              {summaryCard}
            </div>
          </div>
        </div>

        {actionBar}
      </div>
    );
  }

  generatePDF = async () => {
    const {
      iva,
      importeBase,
      importeIva,
      total,
      date,
      accessCode,
      lockerInvoice,
      zoneSelected,
      selectedLocker,
      selectedAccessibility,
      lockerCustomer,
      lockerMatricula,
      lockerPin,
      descriptionZone,
      qrMode,
      Ds_AuthorisationCode,
      Ds_Date,
      Ds_Hour,
      Ds_Amount,
      Ds_MerchantCode,
      Ds_MerchantName,
      Ds_Url,
    } = this.state;

    const { t, i18n } = this.props;

    this.setState({ downloadingPDF: true });

    // Redsys payment authorisation block — only rendered for real card payments.
    // Shared by all three ticket layouts (pin / OTO / OTO-pin) below.
    // ('N/A' is the fallback set when no signed Redsys params are present, so exclude it.)
    const importeOperacion = Ds_Amount ? (Number(Ds_Amount) / 100).toFixed(2) : total;
    const paymentInfo = (Ds_AuthorisationCode && Ds_AuthorisationCode !== "N/A")
      ? [
          "\n",
          { text: `${t("INFORMACIÓN DE PAGO:")}`, style: "invoiceBillingTitle" },
          {
            text: `${t("FUC del comercio")}: ${Ds_MerchantCode}\n ${t("Nombre del comercio")}: ${Ds_MerchantName}\n ${t("URL del comercio")}: ${Ds_Url}\n ${t("Importe de la operación")}: ${importeOperacion} ${currencySymbol()}\n ${t("Código de autorización")}: ${Ds_AuthorisationCode}\n ${t("Fecha / hora de la operación")}: ${Ds_Date} ${Ds_Hour}`,
            style: "invoiceBillingDetails",
          },
        ]
      : [];

    const logocolorDataURL = await this.getImageDataURL(
      "/images/logocolor.png"
    );

    const step1DataURL = await this.getImageDataURL(
      "/images/lockerBasicClosedStep1.png"
    );
    const step2DataURL = await this.getImageDataURL(
      "/images/lockerBasicClosedStep2.png"
    );
    const step3DataURL = await this.getImageDataURL(
      "/images/lockerBasicClosedStep3.png"
    );
    const step4DataURL = await this.getImageDataURL(
      "/images/lockerBasicOpenedStep4.png"
    );

    const step1OTODataURL = await this.getImageDataURL("/images/qr.png");
    const step2OTODataURL = await this.getImageDataURL(
      "/images/lockerOTOStep2.png"
    );
    const step3OTODataURL = await this.getImageDataURL(
      "/images/lockerOpen.png"
    );
    const step4OTODataURL = await this.getImageDataURL(
      "/images/lockerBasicOpenedStep4.png"
    );

    const docDefinition = {
      footer: {
        columns: [
          {
            text: `${t("Más información y garantía en www.vacway.com")}`,
            style: "documentFooterCenter",
          },
        ],
      },
      content: [
        {
          columns: [
            {
              image: logocolorDataURL,
              width: 150,
            },

            [
              {
                text: `${t("TICKET")}`,
                style: "invoiceTitle",
                width: "*",
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: `${t("Factura Simplificada")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: `${lockerInvoice}`,
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `${t("Fecha y Hora")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: new Date().toLocaleString(),
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
        {
          columns: [
            {
              text: `${t("INFORMACIÓN DE TU LOCKER:")}`,
              style: "invoiceBillingTitle",
            },
            {
              text: "VACWAY WATERPROOF S.L",
              style: "invoiceBillingTitle",
            },
          ],
        },
        {
          columns: [
            {
              text: `${t("Nº TAQUILLA")}:  ${lockerMatricula}\n ${t(
                "PIN"
              )}: ${lockerPin}\n ${t("ZONA")}: ${zoneSelected} \n ${t(
                "TIPO"
              )}: ${this.getLockerType(selectedLocker)}\n ${t(
                "ACCESIBLE"
              )}: ${selectedAccessibility} \n ${t(
                "UBICACIÓN"
              )}: ${lockerCustomer}`,
              style: "invoiceBillingDetails",
            },
            {
              text: "Albert Einstein, 46 \n 08223 Terrassa \n Barcelona, España \n NIF: B66983032",
              style: "invoiceBillingDetails",
            },
          ],
        },
        "\n\n",
        {
          table: {
            headerRows: 1,
            widths: ["*", 40, "auto", 40, "auto", 80],

            body: [
              [
                {
                  text: `${t("Producto")}`,
                  style: "itemsHeader",
                },
                {
                  text: `${t("UNIDADES")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE BASE")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("TOTAL")}`,
                  style: ["itemsHeader", "center"],
                },
              ],
              [
                [
                  {
                    text: `${this.getLockerType(selectedLocker)}`,
                    style: "itemTitle",
                  },
                ],
                {
                  text: "1",
                  style: "itemNumber",
                },
                {
                  text: `${importeBase}`,
                  style: "itemNumber",
                },
                {
                  text: `${iva}%`,
                  style: "itemNumber",
                },
                {
                  text: `${importeIva}`,
                  style: "itemNumber",
                },
                {
                  text: `${total}`,
                  style: "itemTotal",
                },
              ],
              // END Items
            ],
          },
          layout: "lightHorizontalLines",
        },
        ...paymentInfo,
        {
          text: `${t("PASO 1")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step1DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("LOCALIZA TU TAQUILLA")}`,
            },
          ],
        },
        {
          text: `${t("PASO 2")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step2DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("TOCA EL TECLADO")}`,
            },
          ],
        },
        {
          text: `${t("PASO 3")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step3DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("INTRODUCE TU PIN")}`,
            },
          ],
        },
        {
          text: `${t("PASO 4")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step4DataURL,
              height: 80,
              width: 120,
            },

            {
              text: `\n${t("ABRE LAS VECES QUE QUIERAS")}`,
            },
          ],
        },
      ],

      styles: {
        // Document Footer
        documentFooterLeft: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "left",
        },
        documentFooterCenter: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "center",
        },
        documentFooterRight: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "right",
        },
        invoiceTitle: {
          fontSize: 22,
          bold: true,
          alignment: "right",
          margin: [0, 0, 0, 15],
        },
        instrucciones: {
          fontSize: 22,
          bold: true,
          alignment: "left",
          margin: [0, 0, 0, 15],
        },
        invoiceSubTitle: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceSubValue: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceBillingTitle: {
          fontSize: 14,
          bold: true,
          alignment: "left",
          margin: [0, 20, 0, 5],
        },
        invoiceBillingDetails: {
          alignment: "left",
          bold: true,
        },
        itemsHeader: {
          margin: [0, 5, 0, 5],
          bold: true,
        },
        itemTitle: {
          bold: true,
        },
        itemNumber: {
          margin: [0, 5, 0, 5],
          alignment: "center",
        },
        itemTotal: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },

        itemsFooterSubTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterSubValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        foto1: {
          alignment: "left",
        },
        itemsFooterTotalTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterTotalValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        signaturePlaceholder: {
          margin: [0, 70, 0, 0],
        },
        signatureName: {
          bold: true,
          alignment: "center",
        },
        signatureJobTitle: {
          italics: true,
          fontSize: 10,
          alignment: "center",
        },
        notesTitle: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 3],
          alignment: "center",
        },
        notesText: {
          fontSize: 10,
        },
        center: {
          alignment: "center",
        },
      },
      defaultStyle: {
        columnGap: 20,
      },
    };

    const docOTODefinition = {
      footer: {
        columns: [
          {
            text: `${t("Más información y garantía en www.vacway.com")}`,
            style: "documentFooterCenter",
          },
        ],
      },
      content: [
        {
          columns: [
            {
              image: logocolorDataURL,
              width: 150,
            },

            [
              {
                text: `${t("TICKET")}`,
                style: "invoiceTitle",
                width: "*",
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: `${t("Factura Simplificada")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: `${lockerInvoice}`,
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `${t("Fecha y Hora")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: new Date().toLocaleString(),
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
        {
          columns: [
            {
              text: `${t("INFORMACIÓN DE TU LOCKER:")}`,
              style: "invoiceBillingTitle",
            },
            {
              text: "VACWAY WATERPROOF S.L",
              style: "invoiceBillingTitle",
            },
          ],
        },
        {
          columns: [
            {
              text: `${t("Nº TAQUILLA")}:  ${lockerMatricula}\n ${t(
                "CÓDIGO DE ACCESO"
              )}: ${accessCode}\n ${t("ZONA")}: ${zoneSelected} \n ${t(
                "TIPO"
              )}: ${this.getLockerType(selectedLocker)}\n ${t(
                "ACCESIBLE"
              )}: ${selectedAccessibility} \n ${t(
                "UBICACIÓN"
              )}: ${lockerCustomer}`,
              style: "invoiceBillingDetails",
            },
            {
              text: "Albert Einstein, 46 \n 08223 Terrassa \n Barcelona, España \n NIF: B66983032",
              style: "invoiceBillingDetails",
            },
          ],
        },
        "\n\n",
        {
          table: {
            headerRows: 1,
            widths: ["*", 40, "auto", 40, "auto", 80],

            body: [
              [
                {
                  text: `${t("Producto")}`,
                  style: "itemsHeader",
                },
                {
                  text: `${t("UNIDADES")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE BASE")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("TOTAL")}`,
                  style: ["itemsHeader", "center"],
                },
              ],
              [
                [
                  {
                    text: `${this.getLockerType(selectedLocker)}`,
                    style: "itemTitle",
                  },
                ],
                {
                  text: "1",
                  style: "itemNumber",
                },
                {
                  text: `${importeBase}`,
                  style: "itemNumber",
                },
                {
                  text: `${iva}%`,
                  style: "itemNumber",
                },
                {
                  text: `${importeIva}`,
                  style: "itemNumber",
                },
                {
                  text: `${total}`,
                  style: "itemTotal",
                },
              ],
              // END Items
            ],
          },
          layout: "lightHorizontalLines",
        },
        ...paymentInfo,
        {
          text: `${t("PASO 1")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step1OTODataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t('APRIETA "ABRIR TAQUILLA" O ESCANEA EL QR')}`,
            },
          ],
        },
        {
          text: `${t("PASO 2")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step2OTODataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("ACCEDE CON TUS CREDENCIALES")}`,
            },
          ],
        },
        {
          text: `${t("PASO 3")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step3OTODataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("SELECCIONA ABRIR AHORA")}`,
            },
          ],
        },
        {
          text: `${t("PASO 4")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step4OTODataURL,
              height: 80,
              width: 120,
            },

            {
              text: `\n${t("DISPONES DE 2 APERTURAS")}`,
            },
          ],
        },
      ],

      styles: {
        // Document Footer
        documentFooterLeft: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "left",
        },
        documentFooterCenter: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "center",
        },
        documentFooterRight: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "right",
        },
        invoiceTitle: {
          fontSize: 22,
          bold: true,
          alignment: "right",
          margin: [0, 0, 0, 15],
        },
        instrucciones: {
          fontSize: 22,
          bold: true,
          alignment: "left",
          margin: [0, 0, 0, 15],
        },
        invoiceSubTitle: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceSubValue: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceBillingTitle: {
          fontSize: 14,
          bold: true,
          alignment: "left",
          margin: [0, 20, 0, 5],
        },
        invoiceBillingDetails: {
          alignment: "left",
          bold: true,
        },
        itemsHeader: {
          margin: [0, 5, 0, 5],
          bold: true,
        },
        itemTitle: {
          bold: true,
        },
        itemNumber: {
          margin: [0, 5, 0, 5],
          alignment: "center",
        },
        itemTotal: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },

        itemsFooterSubTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterSubValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        foto1: {
          alignment: "left",
        },
        itemsFooterTotalTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterTotalValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        signaturePlaceholder: {
          margin: [0, 70, 0, 0],
        },
        signatureName: {
          bold: true,
          alignment: "center",
        },
        signatureJobTitle: {
          italics: true,
          fontSize: 10,
          alignment: "center",
        },
        notesTitle: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 3],
          alignment: "center",
        },
        notesText: {
          fontSize: 10,
        },
        center: {
          alignment: "center",
        },
      },
      defaultStyle: {
        columnGap: 20,
      },
    };

    const docOTOPinDefinition = {
      footer: {
        columns: [
          {
            text: `${t("Más información y garantía en www.vacway.com")}`,
            style: "documentFooterCenter",
          },
        ],
      },
      content: [
        {
          columns: [
            {
              image: logocolorDataURL,
              width: 150,
            },

            [
              {
                text: `${t("TICKET")}`,
                style: "invoiceTitle",
                width: "*",
              },
              {
                stack: [
                  {
                    columns: [
                      {
                        text: `${t("Factura Simplificada")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: `${lockerInvoice}`,
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                  {
                    columns: [
                      {
                        text: `${t("Fecha y Hora")}`,
                        style: "invoiceSubTitle",
                        width: "*",
                      },
                      {
                        text: new Date().toLocaleString(),
                        style: "invoiceSubValue",
                        width: 150,
                      },
                    ],
                  },
                ],
              },
            ],
          ],
        },
        {
          columns: [
            {
              text: `${t("INFORMACIÓN DE TU LOCKER:")}`,
              style: "invoiceBillingTitle",
            },
            {
              text: "VACWAY WATERPROOF S.L",
              style: "invoiceBillingTitle",
            },
          ],
        },
        {
          columns: [
            {
              text: `${t("Nº TAQUILLA")}:  ${lockerMatricula}\n ${t(
                "PIN"
              )}: ${lockerPin}\n ${t("ZONA")}: ${zoneSelected} \n ${t(
                "TIPO"
              )}: ${this.getLockerType(selectedLocker)}\n ${t(
                "ACCESIBLE"
              )}: ${selectedAccessibility} \n ${t(
                "UBICACIÓN"
              )}: ${lockerCustomer}`,
              style: "invoiceBillingDetails",
            },
            {
              text: "Albert Einstein, 46 \n 08223 Terrassa \n Barcelona, España \n NIF: B66983032",
              style: "invoiceBillingDetails",
            },
          ],
        },
        "\n\n",
        {
          table: {
            headerRows: 1,
            widths: ["*", 40, "auto", 40, "auto", 80],

            body: [
              [
                {
                  text: `${t("Producto")}`,
                  style: "itemsHeader",
                },
                {
                  text: `${t("UNIDADES")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE BASE")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("IMPORTE IVA")}`,
                  style: ["itemsHeader", "center"],
                },
                {
                  text: `${t("TOTAL")}`,
                  style: ["itemsHeader", "center"],
                },
              ],
              [
                [
                  {
                    text: `${this.getLockerType(selectedLocker)}`,
                    style: "itemTitle",
                  },
                ],
                {
                  text: "1",
                  style: "itemNumber",
                },
                {
                  text: `${importeBase}`,
                  style: "itemNumber",
                },
                {
                  text: `${iva}%`,
                  style: "itemNumber",
                },
                {
                  text: `${importeIva}`,
                  style: "itemNumber",
                },
                {
                  text: `${total}`,
                  style: "itemTotal",
                },
              ],
              // END Items
            ],
          },
          layout: "lightHorizontalLines",
        },
        ...paymentInfo,
        {
          text: `${t("PASO 1")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step1DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("LOCALIZA TU TAQUILLA")}`,
            },
          ],
        },
        {
          text: `${t("PASO 2")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step2DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("TOCA EL TECLADO")}`,
            },
          ],
        },
        {
          text: `${t("PASO 3")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step3DataURL,
              height: 80,
              width: 80,
            },

            {
              text: `\n${t("INTRODUCE TU PIN")}`,
            },
          ],
        },
        {
          text: `${t("PASO 4")}`,
          style: "notesTitle",
          width: "*",
        },
        {
          columns: [
            {
              image: step4DataURL,
              height: 80,
              width: 120,
            },

            {
              text: `\n${t(
                "ABRE 1 VEZ PARA GUARDAR TUS COSAS, UNA VEZ CIERRES DISPONES DE UNA APERTURA MÁS PARA SACARLAS"
              )}`,
            },
          ],
        },
      ],

      styles: {
        // Document Footer
        documentFooterLeft: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "left",
        },
        documentFooterCenter: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "center",
        },
        documentFooterRight: {
          fontSize: 10,
          margin: [5, 5, 5, 5],
          alignment: "right",
        },
        invoiceTitle: {
          fontSize: 22,
          bold: true,
          alignment: "right",
          margin: [0, 0, 0, 15],
        },
        instrucciones: {
          fontSize: 22,
          bold: true,
          alignment: "left",
          margin: [0, 0, 0, 15],
        },
        invoiceSubTitle: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceSubValue: {
          fontSize: 12,
          alignment: "right",
        },
        invoiceBillingTitle: {
          fontSize: 14,
          bold: true,
          alignment: "left",
          margin: [0, 20, 0, 5],
        },
        invoiceBillingDetails: {
          alignment: "left",
          bold: true,
        },
        itemsHeader: {
          margin: [0, 5, 0, 5],
          bold: true,
        },
        itemTitle: {
          bold: true,
        },
        itemNumber: {
          margin: [0, 5, 0, 5],
          alignment: "center",
        },
        itemTotal: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },

        itemsFooterSubTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterSubValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        foto1: {
          alignment: "left",
        },
        itemsFooterTotalTitle: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "right",
        },
        itemsFooterTotalValue: {
          margin: [0, 5, 0, 5],
          bold: true,
          alignment: "center",
        },
        signaturePlaceholder: {
          margin: [0, 70, 0, 0],
        },
        signatureName: {
          bold: true,
          alignment: "center",
        },
        signatureJobTitle: {
          italics: true,
          fontSize: 10,
          alignment: "center",
        },
        notesTitle: {
          fontSize: 16,
          bold: true,
          margin: [0, 10, 0, 3],
          alignment: "center",
        },
        notesText: {
          fontSize: 10,
        },
        center: {
          alignment: "center",
        },
      },
      defaultStyle: {
        columnGap: 20,
      },
    };

    pdfMake
      .createPdf(
        qrMode === 0
          ? docDefinition
          : qrMode === 3
          ? docOTOPinDefinition
          : docOTODefinition
      )
      .download(`VACWAYlockers-${lockerInvoice}.pdf`);
    this.setState({ downloadingPDF: false });
  };
}

const mapStateToProps = (state) => ({
  auth: true,
});

const mapDispatchToProps = (dispatch) => ({
  push: bindActionCreators(push, dispatch),
  postBookemail: bindActionCreators(postBookemail, dispatch),
  postQrsale: bindActionCreators(postQrsale, dispatch),
  postRedsysGetParams: bindActionCreators(postRedsysGetParams, dispatch),
  fetchCustomer: bindActionCreators(fetchCustomer, dispatch),
  postBooking: bindActionCreators(postBooking, dispatch),
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(TicketView)
);
